import { render, staticRenderFns } from "./Hands.vue?vue&type=template&id=4d2fb514&"
import script from "./Hands.vue?vue&type=script&lang=js&"
export * from "./Hands.vue?vue&type=script&lang=js&"
import style0 from "./Hands.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports